module.exports = __webpack_public_path__ + "img/iphone-screen.5212072b.jpg";